export default __webpack_public_path__ + "static/media/Roboto-Regular.a2580627.woff2";